import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-component',
  templateUrl: './pricing-component.component.html',
  styleUrls: ['./pricing-component.component.css']
})
export class PricingComponentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
